import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

import appRouters from '@/modules/app/routers'
import homeRouters from '@/modules/home/routers'
import discoveryRouters from '@/modules/discovery/routers'
import sermonRouters from '@/modules/sermon/routers'
import developRouters from '@/modules/__develop__/routers'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [...homeRouters, ...discoveryRouters, ...sermonRouters, ...appRouters, ...developRouters],
})

export default router
